import { Button, Card, Empty } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

interface LeadLoadFailureProps {
  notFound?: boolean
  retrying?: boolean
  onRetry: () => void
}

/**
 * Only a 404 says the lead is gone. Every other failed read is offered a retry,
 * so a token that expired or a dropped request does not strand a lead that is
 * still there.
 */
function LeadLoadFailure({
  notFound,
  retrying,
  onRetry
}: LeadLoadFailureProps) {
  const { t } = useTranslation()

  return (
    <Card size={"small"}>
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={t(notFound ? "leadLoad.notFound" : "leadLoad.failed")}
      >
        {!notFound && (
          <Button type={"primary"} loading={retrying} onClick={onRetry}>
            {t("leadLoad.retry")}
          </Button>
        )}
      </Empty>
    </Card>
  )
}

export { LeadLoadFailure }
